export default __webpack_public_path__ + "static/media/pic4.d625a732.jpg";